/*@flow*/

export default function fail(message: string) {
  throw new TypeError('[tcomb] ' + message);
}
